import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {ProductRetrocessionRuleModel} from '../productRetrocessionRule.model';
import {ProductRetrocessionRetrocessionModel} from "../productRetrocessionRetrocession.model";
import {ProductRetrocessionRuleConverter} from "./productRetrocessionRule.converter";

@Injectable()
export class ProductRetrocessionRetrocessionConverter extends HttpModelConverter<ProductRetrocessionRetrocessionModel> {

    constructor(private productRetrocessionRuleConverter: ProductRetrocessionRuleConverter) {
        super();
    }

    protected createInstance(): ProductRetrocessionRetrocessionModel {
        return new ProductRetrocessionRetrocessionModel();
    }

    protected enrichObject(result: ProductRetrocessionRetrocessionModel, src: ProductRetrocessionRetrocessionModel) {
        result.saleResponsibleUser = new UserSummaryConverter().convert(src.saleResponsibleUser);
        result.rules = this.productRetrocessionRuleConverter.convertFromArray(src.rules);
    }
}
